import React from 'react';
import {InputFecha, Etiqueta, ContenedorFiltros, ContenedorFechas, ContenedorFecha, ContenedorBotonBusqueda, BotonPDF} from '../elementos/ElementosDeFormulario'
import { BsFillFileEarmarkPdfFill } from "react-icons/bs"

const BusquedaFecha = ({inputFechaInicio, inputFechaFin, setEstadoBusqueda, handleChange, busqueda}) => {
    return (
        <ContenedorFiltros>
            <ContenedorFechas>
                <ContenedorFecha>
                    <Etiqueta htmlFor="">Fecha Inicio:</Etiqueta>
                    <InputFecha
                        type="date"
                        name="fechaInicio"
                        value={inputFechaInicio}
                        onChange={handleChange}
                    />
                </ContenedorFecha>

                <ContenedorFecha>
                    <Etiqueta htmlFor="">Fecha Fin:</Etiqueta>
                    <InputFecha
                        type="date"
                        name="fechaFin"
                        value={inputFechaFin}
                        onChange={handleChange}
                    />
                </ContenedorFecha>
            </ContenedorFechas>

            <ContenedorBotonBusqueda>
                <BotonPDF title='Generar Reporte PDF' href={busqueda} target='_blank'><BsFillFileEarmarkPdfFill /></BotonPDF>

                <button type="button" className="btn btn-success w-50 h-100"
                onClick={() => setEstadoBusqueda(true)}
                >Buscar</button>
            </ContenedorBotonBusqueda>
        </ContenedorFiltros>
    );
}
 
export default BusquedaFecha;